import 'core-js/features/url';
const buildURLWithParams = ({ base, params }) => {
    const URLInstance = new URL(base);
    Object.entries(params).forEach(([paramKey, paramValue]) => 
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
    URLInstance.searchParams.append(paramKey, paramValue));
    return URLInstance.href;
};
export default buildURLWithParams;
//# sourceMappingURL=buildURLWithParams.js.map